import axios from '@/config/axios'

const model={
    getTable(params){
        return axios({
            url:'/business/discount/buyrecord',
            method:'post',
            data:params
        })
    }
}

export default model


// WEBPACK FOOTER //
// ./src/models/search.js